(function organizationalUnitDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminOrganizationalUnitService', [
            'restUrlBuilder', 'restUrlBuilder', 'restUrlBuilder', 'restUrlBuilder', '$injector', function organizationalUnitService(restUrlBuilder, restUrlBuilderEdr, restUrlBuilderWf, restUrlBuilderAudit, $injector) {

                restUrlBuilder = restUrlBuilder('auth');
                restUrlBuilderAudit = restUrlBuilderAudit('audit')
                restUrlBuilderWf = restUrlBuilderWf('wf')

                this.getById = function (id) {
                    return restUrlBuilder.one('adminOrganizationalUnits', id).get();
                };

                this.getImagesById = function (id) {
                    return restUrlBuilder.one('adminOrganizationalUnits/getImages', id).put();
                };

                this.getTreeOf = function (id) {
                    var params = { TreeOf: id };
                    return restUrlBuilder.all('adminOrganizationalUnits')
                        .get({ params: params });
                };

                this.get = function (name, notInTreeId, allOu, isroot, page, itemsPerPage) {
                    var params = {
                        Name: name
                        , NotInTree: notInTreeId
                        , All: allOu
                        , isRoot: isroot
                        , Page: page
                        , ItemPerPage: itemsPerPage
                    };

                    return restUrlBuilder.all('adminOrganizationalUnits')
                        .get({ params: params });
                };

                this.create = function (organizationalUnit, files, icon, startImage) {
                    if (organizationalUnit == null)
                        throw 'documentType no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.all('adminOrganizationalUnits/Images').url,
                        method: 'POST',
                        fields: { icon: icon, startImage: startImage, ou: JSON.stringify(organizationalUnit) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };

                this.modify = function (organizationalUnit, files, icon, startImage) {
                    if (organizationalUnit == null)
                        throw 'documentType no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.one('adminOrganizationalUnits/', organizationalUnit.id).url,
                        method: 'PUT',
                        fields: { icon: icon, startImage: startImage, ou: JSON.stringify(organizationalUnit) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });

                };

                this.enable = function enable(ou) {
                    if (ou == null) {
                        throw "ou no puede ser null";
                    }

                    return restUrlBuilder.one('adminOrganizationalUnits/enable', ou.id).put();
                };

                this.disable = function disable(ou) {
                    if (ou == null) {
                        throw "ou no puede ser null";
                    }

                    return restUrlBuilder.one('adminOrganizationalUnits/disable', ou.id).put();
                };

                this.removeEdr = function edr(ou) {
                    return restUrlBuilderEdr.one('OrganizationalUnits/OuDeleteRecords', ou).delete();
                };

                this.removeAuth = function removeAuth(ou) {
                    return restUrlBuilder.one('AdminOrganizationalUnits/HardDelete', ou).delete();
                };

                this.removeWf = function removeWf(ou) {

                    return restUrlBuilderWf.one('OrganizationalUnits/OuDeleteRecords', ou).delete();
                };

                this.removeAudit = function removeWF(ou) {

                    return restUrlBuilderAudit.one('OrganizationalUnits/OuDeleteRecords', ou).delete();
                };
            }
        ]);
})();